import type { ThemeProviderProps } from "flowbite-react";

export const theme: ThemeProviderProps["theme"] = {
  toggleSwitch: {
    root: {
      active: { on: "bg-black rounded-full", off: "bg-gray-200" },
    },
  },
  button: {
    color: {
      primary: "bg-primary-500 hover:bg-primary-550 text-white",
      gray: "text-gray-900 bg-white border border-gray-200 enabled:hover:bg-gray-100 enabled:hover:text-cyan-700 :ring-cyan-700 focus:text-cyan-700 dark:bg-transparent dark:text-gray-400 dark:border-gray-600 dark:enabled:hover:text-white dark:enabled:hover:bg-gray-700 focus:ring-2",
      green:
        "text-white bg-green-400 border border-green-300 enabled:hover:bg-green-100 focus:ring-4 focus:ring-green-300 dark:bg-green-600 dark:text-white dark:border-green-600 dark:enabled:hover:bg-green-700 dark:enabled:hover:border-green-700 dark:focus:ring-green-700",
    },
    outlineColor: {
      gray: "border-gray-200 text-gray-900",
    },
  },
  label: {
    root: {
      colors: {
        gray: "gray-900 text-base",
      },
    },
  },
  textInput: {
    field: {
      input: {
        colors: {
          gray: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
        },
      },
    },
  },
  select: {
    field: {
      select: {
        colors: {
          gray: "bg-gray-50 border-gray-300 text-gray-900 focus:border-cyan-500 focus:ring-cyan-500 dark:border-primary-600 dark:bg-transparent dark:text-white dark:placeholder-white dark:focus:border-primary-500 dark:focus:ring-primary-500 autofill:bg-transparent",
        },
      },
    },
  },
  carousel: {
    // Keep your existing scrollContainer
    scrollContainer: {
      base: "flex h-full snap-mandatory overflow-y-hidden overflow-x-scroll scroll-smooth",
    },
    // ADD THESE NEW SECTIONS FOR INDICATORS AND CONTROLS
    indicators: {
      active: {
        // This is for the currently active dot
        // 'on' applies when the indicator is active
        on: 'w-6 bg-white', // Make it wider and white
        // 'off' applies when the indicator is inactive
        // We'll set the base to white circles, so 'off' can keep transparent/dimmed if desired,
        // or also be pure white. Let's make it pure white to match your example.
        off: 'bg-white',
      },
      base: 'h-2 w-2 rounded-full bg-white transition-all duration-300', // Base style for all dots: small, white, circular, with transition
      // 'wrapper' styles the container of the indicators (if needed, usually default is fine)
      wrapper: 'absolute bottom-5 left-1/2 flex -translate-x-1/2 space-x-2', // Adjust position/spacing if needed
    },
    control: {
      // Styles for the left/right navigation arrows
      // If you want them completely invisible but functional, you might set bg-transparent and text-transparent
      // Or you can match the transparent white overlay from your coffee image
      base: 'inline-flex h-8 w-8 items-center justify-center rounded-full bg-white/30 group-hover:bg-white/50 group-focus:outline-none group-focus:ring-4 group-focus:ring-white dark:bg-gray-800/30 dark:group-hover:bg-gray-800/60 dark:group-focus:ring-gray-800/70 sm:h-10 sm:w-10',
      icon: 'h-5 w-5 text-white sm:h-6 sm:w-6',
    },
  },
  progress: {
    base: "w-full overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700",
    label: "mb-1 flex justify-between font-medium dark:text-white",
    bar: "rounded-full text-center font-medium leading-none text-cyan-300 dark:text-cyan-100 space-x-2",
    color: {
      primary: "bg-primary-500 hover:bg-primary-550 text-white",
      dark: "bg-gray-600 dark:bg-gray-300",
      blue: "bg-blue-600",
      red: "bg-red-600 dark:bg-red-500",
      green: "bg-green-600 dark:bg-green-500",
      yellow: "bg-yellow-400",
      indigo: "bg-indigo-600 dark:bg-indigo-500",
      purple: "bg-purple-600 dark:bg-purple-500",
      cyan: "bg-cyan-600",
      gray: "bg-gray-500",
      lime: "bg-lime-600",
      pink: "bg-pink-500",
      teal: "bg-teal-600",
    },
    size: {
      sm: "h-1.5",
      md: "h-2.5",
      lg: "h-4",
      xl: "h-6",
    },
  },
  radio: {
    base: "h-4 w-4 border border-gray-300 text-black focus:ring-2 focus:ring-black",
  },
  checkbox: {
    base: "h-4 w-4 rounded border border-gray-300 bg-gray-100 focus:ring-2 dark:border-gray-600 dark:bg-gray-700",
    color: {
      default:
        "text-cyan-600 focus:ring-cyan-600 dark:ring-offset-gray-800 dark:focus:ring-cyan-600",
      green:
        "text-green-400 focus:ring-green-300 dark:ring-offset-green-400 dark:focus:ring-green-300",
    },
  },
};